import React from "react";
import "./choose.css";
function WhyChooseUs() {
  return (
    <div className="why-choose-section">
      <div className="container">
        <div className="row justify-content-between">

          {/* Left Content */}
          <div className="col-lg-6">
            <h2 className="section-title">Why Businesses Choose Us</h2>
            <p>
               We provide reliable manufacturing solutions with
              advanced machinery, premium quality materials,
              and strong production support for businesses worldwide.
            </p>

            <div className="row my-5">

              {/* Feature 1 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://www.svgrepo.com/show/171923/factory.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Advanced Manufacturing</h3>
                  <p>Modern production facilities ensuring
                    precision and consistent quality output.</p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://staging.svgrepo.com/show/94814/quality.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Premium Quality Products</h3>
                  <p>High-grade materials and strict quality
                    control for long-lasting durability.</p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://www.svgrepo.com/show/48151/team-support.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Dedicated Business Support</h3>
                  <p>Professional assistance and customized
                    solutions tailored for your business needs.</p>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="col-6 col-md-6">
                <div className="feature">
                  <div className="icon">
                    <img src="https://www.svgrepo.com/show/116369/earth-globe-tool.svg" alt="icon" className="img-fluidsvg" />
                  </div>
                  <h3>Reliable Global Supply</h3>
                  <p>Efficient logistics and timely delivery
                    for domestic and international clients.</p>
                </div>
              </div>

            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-5">
            <div className="img-wrap">
              <img
                src="/images/why-choose-us-img.jpg"
                alt="why choose us"
                className="img-fluid"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;